// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               unknown
// source: common/model/ApiResultCodePt.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "io.teamsillim.fightbracket.idl.common.model";

/** API 표준 Response Code 패킷 */
export enum ApiResultCodePayload {
  /** UNKNOWN_ERROR - 알 수 없는 오류 */
  UNKNOWN_ERROR = 0,
  /** SUCCESS - 성공 */
  SUCCESS = 1,
  /** NO_AUTH_ENDPOINT - Endpoint 미권한 */
  NO_AUTH_ENDPOINT = 2,
  /** DB_SAVE_FAIL - DB 저장 중, 에러가 발생 하는 코드, 해당 코드가 발생 하면 제일 먼저 확인할 것 */
  DB_SAVE_FAIL = 3,
  /** VALIDATION_ERROR - 데이터 변환 작업 중 에러가 발생한 경우 */
  VALIDATION_ERROR = 4,
  /** AUTHENTICATION_ERROR - 인증 오류 (토큰) */
  AUTHENTICATION_ERROR = 5,
  /** INTERNAL_ERROR - 내부 로직 에러 */
  INTERNAL_ERROR = 6,
  /** FILE_CONTENT_EMPTY - 빈값 파일이 넘어온 에러 */
  FILE_CONTENT_EMPTY = 7,
  /** FILE_UPLOAD_FAIL - 파일 업로드 실패 */
  FILE_UPLOAD_FAIL = 8,
  /** DB_SEARCH_FAIL - DB 조회 오류 */
  DB_SEARCH_FAIL = 9,
  UNRECOGNIZED = -1,
}

export function apiResultCodePayloadFromJSON(object: any): ApiResultCodePayload {
  switch (object) {
    case 0:
    case "UNKNOWN_ERROR":
      return ApiResultCodePayload.UNKNOWN_ERROR;
    case 1:
    case "SUCCESS":
      return ApiResultCodePayload.SUCCESS;
    case 2:
    case "NO_AUTH_ENDPOINT":
      return ApiResultCodePayload.NO_AUTH_ENDPOINT;
    case 3:
    case "DB_SAVE_FAIL":
      return ApiResultCodePayload.DB_SAVE_FAIL;
    case 4:
    case "VALIDATION_ERROR":
      return ApiResultCodePayload.VALIDATION_ERROR;
    case 5:
    case "AUTHENTICATION_ERROR":
      return ApiResultCodePayload.AUTHENTICATION_ERROR;
    case 6:
    case "INTERNAL_ERROR":
      return ApiResultCodePayload.INTERNAL_ERROR;
    case 7:
    case "FILE_CONTENT_EMPTY":
      return ApiResultCodePayload.FILE_CONTENT_EMPTY;
    case 8:
    case "FILE_UPLOAD_FAIL":
      return ApiResultCodePayload.FILE_UPLOAD_FAIL;
    case 9:
    case "DB_SEARCH_FAIL":
      return ApiResultCodePayload.DB_SEARCH_FAIL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ApiResultCodePayload.UNRECOGNIZED;
  }
}

export function apiResultCodePayloadToJSON(object: ApiResultCodePayload): string {
  switch (object) {
    case ApiResultCodePayload.UNKNOWN_ERROR:
      return "UNKNOWN_ERROR";
    case ApiResultCodePayload.SUCCESS:
      return "SUCCESS";
    case ApiResultCodePayload.NO_AUTH_ENDPOINT:
      return "NO_AUTH_ENDPOINT";
    case ApiResultCodePayload.DB_SAVE_FAIL:
      return "DB_SAVE_FAIL";
    case ApiResultCodePayload.VALIDATION_ERROR:
      return "VALIDATION_ERROR";
    case ApiResultCodePayload.AUTHENTICATION_ERROR:
      return "AUTHENTICATION_ERROR";
    case ApiResultCodePayload.INTERNAL_ERROR:
      return "INTERNAL_ERROR";
    case ApiResultCodePayload.FILE_CONTENT_EMPTY:
      return "FILE_CONTENT_EMPTY";
    case ApiResultCodePayload.FILE_UPLOAD_FAIL:
      return "FILE_UPLOAD_FAIL";
    case ApiResultCodePayload.DB_SEARCH_FAIL:
      return "DB_SEARCH_FAIL";
    case ApiResultCodePayload.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** 일반 API 응답 payload */
export interface ApiResultPayload {
  /** 성공 여부 */
  isSuccess: boolean;
  /** 결과 코드 */
  code: ApiResultCodePayload;
  /** api message */
  message: string;
}

function createBaseApiResultPayload(): ApiResultPayload {
  return { isSuccess: false, code: 0, message: "" };
}

export const ApiResultPayload: MessageFns<ApiResultPayload> = {
  encode(message: ApiResultPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.isSuccess !== false) {
      writer.uint32(8).bool(message.isSuccess);
    }
    if (message.code !== 0) {
      writer.uint32(16).int32(message.code);
    }
    if (message.message !== "") {
      writer.uint32(26).string(message.message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApiResultPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApiResultPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.isSuccess = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.code = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ApiResultPayload {
    return {
      isSuccess: isSet(object.isSuccess) ? globalThis.Boolean(object.isSuccess) : false,
      code: isSet(object.code) ? apiResultCodePayloadFromJSON(object.code) : 0,
      message: isSet(object.message) ? globalThis.String(object.message) : "",
    };
  },

  toJSON(message: ApiResultPayload): unknown {
    const obj: any = {};
    if (message.isSuccess !== false) {
      obj.isSuccess = message.isSuccess;
    }
    if (message.code !== 0) {
      obj.code = apiResultCodePayloadToJSON(message.code);
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ApiResultPayload>, I>>(base?: I): ApiResultPayload {
    return ApiResultPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ApiResultPayload>, I>>(object: I): ApiResultPayload {
    const message = createBaseApiResultPayload();
    message.isSuccess = object.isSuccess ?? false;
    message.code = object.code ?? 0;
    message.message = object.message ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
